import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const AnnouncementBar = () => {
  return (
    <Link
      to="/contact"
      className="block bg-secondary py-2 hover:bg-secondary/90 transition-colors"
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-2 text-secondary-foreground font-semibold text-sm md:text-base">
          <span>🌿 Get Your Free Lawn Care Estimate Today!</span>
          <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
};
